// PR-AM — Per-tenant tab title driven by hostname-resolved org.
//
// Title rules per Rickard's spec:
//   - Pre-resolve (Q1): empty string (osynligt för användaren)
//   - UnknownHostname fallback (Q2): "Boply"
//   - Org resolved (Q5, Option C): org.name only — no "| Boply" suffix,
//     no per-page prefix ("Bookings - HallNamn" etc.)
//
// Replaces:
//   - Hardcoded `<title>Actionpadel</title>` in index.html (now empty)
//   - `document.title = organization.name` in useOrganization.tsx
//   - `document.title` setting in App.tsx DynamicTitle component
//
// Single source of truth: PublicOrg (hostname-based, resolved before
// auth). Authenticated users on the same hostname see the same title.

import { useEffect } from "react";
import { usePublicOrgContext } from "@/contexts/PublicOrgContext";

const UNKNOWN_HOSTNAME_TITLE = "Boply";
const PRE_RESOLVE_TITLE = "";

export function usePublicTitle() {
  const { org, isLoading, isUnknownHostname } = usePublicOrgContext();

  useEffect(() => {
    if (isLoading) {
      document.title = PRE_RESOLVE_TITLE;
      return;
    }
    if (isUnknownHostname) {
      document.title = UNKNOWN_HOSTNAME_TITLE;
      return;
    }
    if (org?.name) {
      document.title = org.name;
    }
  }, [isLoading, isUnknownHostname, org?.name]);
}
